import { render, staticRenderFns } from "./editVoyageInvoice.vue?vue&type=template&id=5052bd7d&scoped=true"
import script from "./editVoyageInvoice.vue?vue&type=script&lang=js"
export * from "./editVoyageInvoice.vue?vue&type=script&lang=js"
import style0 from "./editVoyageInvoice.vue?vue&type=style&index=0&id=5052bd7d&prod&lang=scss"
import style1 from "./editVoyageInvoice.vue?vue&type=style&index=1&id=5052bd7d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5052bd7d",
  null
  
)

export default component.exports